export default __webpack_public_path__ + "e8d199fef0eb9dc8b1fa3a137bef2dce.svg";